import Component from "../../lib/component";

export const DropdownBtnConfig = {
    componentTypeKey: 'DropdownBtn',
    baseHtmlClass: 'dropdown_btn',
    selector: '.dropdown_btn',
};

export class DropdownBtn extends Component {

    static get config() {
        return DropdownBtnConfig;
    }

    constructor(id_or_element, dropdown) {
        super({
            element: id_or_element,
            config: DropdownBtn.config
        });

        this.dropdown = dropdown;

        this.element.classList.add(DropdownBtn.config.baseHtmlClass);

        this.element.addEventListener('click', this.handleClick.bind(this));
        this.render();
    }

    handleClick(event) {
        event.preventDefault();
        this.toggle();
        this.dropdown.render();
    }

    render() {
        this.swapHtmlClassStates(this.isOpen(), 'open', 'closed');
    }

    toggle() {
        this.dropdown.toggle();
    }

    isOpen() {
        return this.dropdown.isOpen();
    }

}